import React from 'react';
import TouchableElement from '@components/common/touchableElement';
import { StyleProp, View, ViewStyle } from 'react-native';
import Svg from '@styles/icons/svg';
import { ColorFunction } from '@styles/colors/types';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { ICON_BUTTON_PADDING } from '@v2/pages/common/constants/base.constants';
import { SimpleOnPress } from '@interfaces/base';

export interface AddButtonWithHover extends Partial<SimpleOnPress> {
  C: ColorFunction;
  style?: StyleProp<ViewStyle>;
  scale: ScaleFunction;
  iconColor?: string;
}

const AddButtonWithHover = ({ C, scale, onPress, style, iconColor = 'Link/Light/Primary' }: AddButtonWithHover) => {
  return (
    <TouchableElement onPress={onPress}>
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              backgroundColor: C(pressHoverColor('Button/Light/Only Text')),
              padding: scale(ICON_BUTTON_PADDING),
              borderRadius: scale(18),
              justifyContent: 'center',
              alignItems: 'center',
            },
            style,
          ]}
        >
          <Svg icon="plus" width={scale(20)} height={scale(20)} color={iconColor} />
        </View>
      )}
    </TouchableElement>
  );
};

export default AddButtonWithHover;
